module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 py-3"
  }, [(_vm.reservation.payments) ? _c('div', _vm._l((_vm.reservation.payments), function(payment) {
    return _c('div', {
      staticClass: "d-flex flex-row justify-content-between"
    }, [_c('span', [_vm._v(_vm._s(payment.date))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(payment.value + ' ' + payment.currency))])])
  }), 0) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-37a81230", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37a81230"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEdit/TabPayments.vue
// module id = 1846
// module chunks = 0